import { render, staticRenderFns } from "./MajorProjects.vue?vue&type=template&id=2055048b"
import script from "./MajorProjects.vue?vue&type=script&lang=js"
export * from "./MajorProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports